import { FaTools } from "react-icons/fa";
import { FaBrush } from "react-icons/fa6";
import { MdOutlinePlumbing } from "react-icons/md";
import { TbAirConditioning } from "react-icons/tb";


export const homeServicesList = [
  {
    name: "Electro-Mechanical Services",
    Icon:FaTools,
    desc: " We offer comprehensive electrical and electromechanical solutions designed to ensure the safety, efficiency . "
  },
  {
    name: "Painting & Decorative Works",
    Icon:FaBrush,
    desc: "Our Plumbing & Water Systems services provide complete solutions for all your water management needs.  "
  },
  {
    name: "Plumbing & Water Systems",
    Icon:MdOutlinePlumbing,
    desc: "Transform your space with our Painting & Decorative Works services, designed to add beauty and style to your property.  "
  },
  {
    name: "HVAC Systems",
    Icon:TbAirConditioning,
    desc: " Our HVAC Systems services ensure your building remains comfortable and well-ventilated throughout the year.  "
  }
];
